import { Icon } from "./Icon";
import { useI18n } from "../lib/i18n";

/**
 * A one-line notice, shown only when the family is reading in Urdu.
 *
 * The Urdu catalogue is translated screen by screen and the curriculum content
 * behind it is being reviewed level by level, so a family reading in Urdu will
 * still meet the occasional English sentence or an awkward phrase. Saying so is
 * better than letting them assume the translation is finished and wonder
 * whether they have misread something — and the same line turns a defect into a
 * report, because it says where to send a correction.
 *
 * Renders nothing in English: there is nothing there to warn anyone about.
 *
 * `onSuggest` is optional because the suggestions page needs an account, so the
 * sign-in screen shows the sentence without the button.
 */
export function UrduBetaNotice({ onSuggest }: { onSuggest?: () => void }) {
  const { t, locale } = useI18n();
  if (locale !== "ur") return null;

  return (
    <div className="locale-notice" role="note">
      <Icon name="message" size={15} />
      <p>{t("top.urduBeta")}</p>
      {onSuggest ? (
        <button className="soft-button" onClick={onSuggest}>
          {t("top.urduBetaAction")}
        </button>
      ) : null}
    </div>
  );
}
